import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  Container,
  Button,
  Input,
  DropdownToggle,
  DropdownMenu,
  Dropdown,
  DropdownItem,
  Row,
  Col,
  Card,
  CardBody,
  UncontrolledDropdown,
} from "reactstrap";
import { Link } from "react-router-dom";
import { isEmpty, map } from "lodash";

import FeatherIcon from "feather-icons-react";
import Picker from 'emoji-picker-react';
import avatar2 from "../../assets/images/BotLogo.png";
import userDummayImage from "../../assets/images/users/user-dummy-img.jpg";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { PdfSummarizationAPI } from "../../helpers/firebase_helper";
import { useSelector } from "react-redux";

const ChatBot = () => {
  const [customActiveTab, setcustomActiveTab] = useState("1");
  const [sessionId, setSessionId] = useState("");
  const ref = useRef();
  const [isInfoDetails, setIsInfoDetails] = useState(false);
  const [Chat_Box_Username, setChat_Box_Username] = useState("Lisa Parker");
  const [Chat_Box_Image, setChat_Box_Image] = useState(avatar2);
  const [currentRoomId, setCurrentRoomId] = useState(1);
  const [messageBox, setMessageBox] = useState(null);
  const [curMessage, setcurMessage] = useState("");
  const [search_Menu, setsearch_Menu] = useState(false);
  const [settings_Menu, setsettings_Menu] = useState(false);
  const [reply, setreply] = useState("");
  const [emojiPicker, setemojiPicker] = useState(false);
  const [emojiArray, setemojiArray] = useState("");

  const [currentUser, setCurrentUser] = useState({
    name: "Anna Adame",
  });

  const [messages, setMessages] = useState([
    {
      id: 1,
      sender: "Beacon Bot",
      message: "Hello! I'm Beacon Eng AI Chatbot. How can I help you today?",
      createdAt: new Date(),
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [isBotTyping, setIsBotTyping] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  
  const data = useSelector((state) => state.UserDetails);

  useEffect(() => {
    setCurrentUser({
      name: data?.userDetails?.firstName || "Anna Adame",
    });
  }, [data]);

  const toggleSearch = () => setsearch_Menu(!search_Menu);
  const toggleInfo = () => setIsInfoDetails(!isInfoDetails);
  const toggleSettings = () => setsettings_Menu(!settings_Menu);

  const userChatOpen = (id, name, status, roomId, image) => {
    setChat_Box_Username(name);
    setChat_Box_Image(image);
  };

  const deleteMessageLocal = (messageId) => {
    setMessages((prev) => prev.filter((m) => m.id !== messageId));
  };

  const handleCkick = (e) => {
    e.stopPropagation();
    
    let messageElement = e.target.closest('.message-box-drop')?.closest('.chat-list')?.querySelector('.ctext-wrap-content');
    
    if (!messageElement) {
      messageElement = e.target.closest('.conversation-list')?.querySelector('.ctext-wrap-content');
    }
    
    if (!messageElement) {
      messageElement = e.target.closest('.user-chat-content')?.querySelector('.ctext-wrap-content');
    }
    
    if (messageElement && messageElement.textContent) {
      navigator.clipboard.writeText(messageElement.textContent.trim());
      
      const copyAlert = document.getElementById("copyClipBoard");
      if (copyAlert) {
        copyAlert.style.display = "block";
        setTimeout(() => {
          copyAlert.style.display = "none";
        }, 2000);
      }
    } else {
      console.warn('Message content not found for copying');
    }
  };

  const addMessage = (roomId, sender) => {
    if (!curMessage || isLoading) return;

    const userMsg = {
      id: Math.floor(Math.random() * 1000000),
      sender,
      message: curMessage,
      createdAt: new Date(),
    };
    setMessages((prev) => [...prev, userMsg]);
    setcurMessage("");

    (async () => {
      setIsLoading(true);
      setIsBotTyping(true);

      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }

      try {
        const resp = await PdfSummarizationAPI.createChat(userMsg.message, sessionId);
        if (typingTimeout) {
          clearTimeout(typingTimeout);
        }

        let botText = "(no response)";
        let data = resp.response;
        if (data) {
          botText = data.reply || data.response || data.message || data.output || JSON.stringify(data);
          if (typeof botText === "string") botText = botText.replace(/^[\s-]+/, "").trim();
        }
        setSessionId(resp?.result?.sessionId);

        setIsBotTyping(false);

        const botMsg = {
          id: Math.floor(Math.random() * 1000000),
          sender: "Beacon Bot",
          message: resp?.result?.response,
          createdAt: new Date(),
        };
        setMessages((prev) => [...prev, botMsg]);
      } catch (err) {
        setIsBotTyping(false);
        if (typingTimeout) {
          clearTimeout(typingTimeout);
        }

        const errMsg = {
          id: Math.floor(Math.random() * 1000000),
          sender: "Beacon Bot",
          message: `Error: ${err.message}`,
          createdAt: new Date(),
        };
        setMessages((prev) => [...prev, errMsg]);
      } finally {
        setIsLoading(false);
      }
    })();
  };

  const scrollToBottom = useCallback(() => {
    if (messageBox) {
      messageBox.scrollTop = messageBox.scrollHeight + 1000;
    }
  }, [messageBox]);

  useEffect(() => {
    if (!isEmpty(messages)) scrollToBottom();
  }, [messages, isBotTyping, scrollToBottom]);

  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addMessage(currentRoomId, currentUser.name);
    }
  };

  const onEmojiClick = (event, emojiObject) => {
    setemojiArray([...emojiArray, emojiObject.emoji]);
    setcurMessage(curMessage + event.emoji);
  };

  const searchMessages = () => {
    const searchInput = document.getElementById("searchMessage");
    if (!searchInput) return;
    
    const searchFilter = searchInput.value.toUpperCase();
    const searchUL = document.getElementById("users-conversation");
    if (!searchUL) return;
    
    const searchLI = searchUL.getElementsByTagName("li");
    Array.prototype.forEach.call(searchLI, function (search) {
      const a = search.getElementsByTagName("p")[0] || search.querySelector('.ctext-wrap-content');
      const txtValue = a ? (a.textContent || a.innerText || '') : '';
      if (txtValue.toUpperCase().indexOf(searchFilter) > -1) {
        search.style.display = "";
      } else {
        search.style.display = "none";
      }
    });
  };

  document.title = "Beacon Eng. Chat Bot";

  return (
    <React.Fragment>
      <style jsx>{`
        .typing-indicator {
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 8px 12px;
          background: #f1f3f4;
          border-radius: 18px;
          min-width: 60px;
          height: 24px;
        }
        .typing-indicator span {
          width: 8px;
          height: 8px;
          background: #9e9e9e;
          border-radius: 50%;
          animation: typing 1.4s infinite ease-in-out;
        }
        .typing-indicator span:nth-child(2) {
          animation-delay: 0.2s;
        }
        .typing-indicator span:nth-child(3) {
          animation-delay: 0.4s;
        }
        @keyframes typing {
          0%, 60%, 100% {
            transform: translateY(0);
            opacity: 0.4;
          }
          30% {
            transform: translateY(-10px);
            opacity: 1;
          }
        }
      `}</style>

      <Container fluid>
        <div className="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n6 p-2">
          <div className="user-chat user-chat-show w-100 overflow-hidden">
            <div className="chat-content d-lg-flex">
              <div className="w-100 overflow-hidden position-relative">
                {/* Topbar code remains same */}
                <div className="p-2 user-chat-topbar">
                  <Row className="align-items-center">
                    <Col sm={4} xs={8}>
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1 overflow-hidden">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 chat-user-img online user-own-img align-self-center me-3 ms-0">
                              {Chat_Box_Image === undefined ? (
                                <img src={userDummayImage} className="rounded-circle avatar-xs" alt="" />
                              ) : (
                                <img src={Chat_Box_Image} className="rounded-circle avatar-xs" alt="" />
                              )}
                              <span className="user-status"></span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <h5 className="text-truncate mb-0 fs-14">
                                <a className="text-reset username" href="#userProfileCanvasExample">
                                  Beacon Eng AI Chatbot
                                </a>
                              </h5>
                              <p className="text-truncate text-muted fs-12 mb-0 userStatus">
                                <small>Active</small>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col sm={8} xs={4}>
                      <ul className="list-inline user-chat-nav text-end mb-0">
                        <li className="list-inline-item m-0">
                          <Dropdown isOpen={search_Menu} toggle={toggleSearch}>
                            <DropdownToggle className="btn btn-ghost-secondary btn-icon" tag="button">
                              <FeatherIcon icon="search" className="icon-sm" />
                            </DropdownToggle>
                            <DropdownMenu className="p-0 dropdown-menu-end dropdown-menu-lg">
                              <div className="p-2">
                                <div className="search-box">
                                  <Input
                                    onKeyUp={searchMessages}
                                    type="text"
                                    className="form-control bg-light border-light"
                                    placeholder="Search here..."
                                    id="searchMessage"
                                  />
                                  <i className="ri-search-2-line search-icon"></i>
                                </div>
                              </div>
                            </DropdownMenu>
                          </Dropdown>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </div>

                <div className="position-relative" id="users-chat">
                  <div className="chat-conversation p-3 p-lg-4" id="chat-conversation">
                    <PerfectScrollbar containerRef={ref => setMessageBox(ref)}>
                      <div id="elmLoader"></div>
                      <ul className="list-unstyled chat-conversation-list" id="users-conversation">
                        {messages && map(messages, (message, key) => (
                          <li
                            className={message.sender === currentUser.name ? "chat-list right" : "chat-list left"}
                            key={key}
                          >
                            <div className="conversation-list">
                              {message.sender === currentUser.name && (
                                <div className="chat-avatar">
                                  <img src={userDummayImage} alt="" />
                                </div>
                              )}

                              <div className="user-chat-content">
                                <div className="ctext-wrap">
                                  <div className="ctext-wrap-content">
                                    {message.message}
                                  </div>
                                  <UncontrolledDropdown className="align-self-start message-box-drop">
                                    <DropdownToggle href="#" className="btn nav-btn" tag="i">
                                      <i className="ri-more-2-fill"></i>
                                    </DropdownToggle>
                                    <DropdownMenu>
                                     <DropdownItem href="#" onClick={handleCkick}>
                                        <i className="ri-file-copy-line me-2 text-muted align-bottom"></i>Copy
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </div>
                                <div className="conversation-name">
                                  <small className="text-muted time">
                                    {new Date(message.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                  </small>
                                  <span className="text-success check-message-icon">
                                    <i className="ri-check-double-line align-bottom"></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}

                        {isBotTyping && (
                          <li className="chat-list left">
                            <div className="conversation-list">
                              <div className="chat-avatar">
                                <img src={avatar2} alt="Bot" />
                              </div>
                              <div className="user-chat-content">
                                <div className="ctext-wrap">
                                  <div className="ctext-wrap-content">
                                    <div className="typing-indicator">
                                      <span></span>
                                      <span></span>
                                      <span></span>
                                    </div>
                                  </div>
                                </div>
                                <div className="conversation-name">
                                  <small className="text-muted time">
                                    {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                  </small>
                                </div>
                              </div>
                            </div>
                          </li>
                        )}
                      </ul>
                    </PerfectScrollbar>
                  </div>
                  <div
                    className="alert alert-warning alert-dismissible copyclipboard-alert px-4 fade show"
                    id="copyClipBoard"
                    role="alert"
                    style={{ display: 'none' }}
                  >
                    Message copied
                  </div>
                  {emojiPicker && (
                    <div className="alert pickerEmoji">
                      <Picker disableSearchBar={true} onEmojiClick={onEmojiClick} />
                    </div>
                  )}
                </div>

                <div className="chat-input-section p-2 p-lg-2">
                  <form id="chatinput-form">
                    <Row className="g-0 align-items-center">
                      <div className="col-auto">
                        <div className="chat-input-links me-2">
                          <button
                            type="button"
                            className="btn btn-link text-decoration-none emoji-btn"
                            id="emoji-btn"
                            onClick={() => setemojiPicker(!emojiPicker)}
                          >
                            <i className="bx bx-smile align-middle"></i>
                          </button>
                        </div>
                      </div>
                      <div className="col">
                        <div className="chat-input-feedback">Please Enter a Message</div>
                        <input
                          type="text"
                          value={curMessage}
                          onKeyDown={onKeyPress}
                          onChange={e => setcurMessage(e.target.value)}
                          className="form-control chat-input bg-light border-light"
                          id="chat-input"
                          placeholder="Type your message..."
                        />
                      </div>
                      <div className="col-auto">
                        <div className="chat-input-links ms-2">
                          <Button
                            type="button"
                            color="success"
                            onClick={() => {
                              addMessage(currentRoomId, currentUser.name);
                              setemojiPicker(false);
                              setemojiArray("");
                            }}
                            disabled={isLoading || !curMessage}
                            className="chat-send waves-effect waves-light"
                          >
                            <i className="ri-send-plane-2-fill align-bottom"></i>
                          </Button>
                        </div>
                      </div>
                    </Row>
                  </form>
                </div>

                <div className={reply ? "replyCard show" : "replyCard"}>
                  <Card className="mb-0">
                    <CardBody className="py-3">
                      <div className="replymessage-block mb-0 d-flex align-items-start">
                        <div className="flex-grow-1">
                          <h5 className="conversation-name">{reply?.sender}</h5>
                          <p className="mb-0">{reply?.message}</p>
                        </div>
                        <div className="flex-shrink-0">
                          <button
                            type="button"
                            className="btn btn-sm btn-link mt-n2 me-n3 fs-18"
                            onClick={() => setreply("")}
                          >
                            <i className="bx bx-x align-middle"></i>
                          </button>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default ChatBot;

